import { createAction } from 'redux-actions';

import { fetchUserDevices, removeAccountDevice } from '@app/services/accountService';

export const loadingUserDevices = createAction('ACCOUNT/LOADING_USER_DEVICES');
export const successGetUserDevices = createAction('ACCOUNT/SUCCESS_GET_USER_DEVICES');
export const failureGetUserDevices = createAction('ACCOUNT/FAILTURE_GET_USER_DEVICES');
export const removingUserDevice = createAction('ACCOUNT/REMOVING_USER_DEVICE');
export const successRemoveUserDevice = createAction('ACCOUNT/SUCCESS_REMOVE_USER_DEVICE');
export const failureRemoveUserDevice = createAction('ACCOUNT/FAILTURE_REMOVE_USER_DEVICE');
export const removingAllUserDevices = createAction('ACCOUNT/REMOVING_ALL_USER_DEVICES');
export const successRemoveAllUserDevices = createAction('ACCOUNT/SUCCESS_REMOVE_USER_DEVICES');
export const failureRemoveAllUserDevices = createAction('ACCOUNT/FAILTURE_REMOVE_ALL_USER_DEVICES');
export const resetDevices = createAction('PAYMENT/RESET_DEVICES');

export function getUserDevices() {
  return (dispatch, getState) => {
    const { user: { authToken } } = getState();
    dispatch(loadingUserDevices());
    fetchUserDevices({ authToken })
      .then((devices = []) => {
        dispatch(successGetUserDevices(devices));
      })
      .catch((error) => {
        console.log('Error on fetch user devices', error);
        dispatch(failureGetUserDevices(error));
      });
  };
}

export function removeUserDevice(casDeviceId) {
  return (dispatch, getState) => {
    const { user: { authToken } } = getState();
    dispatch(removingUserDevice(casDeviceId));
    return removeAccountDevice({ casDeviceId }, authToken)
      .then(() => {
        dispatch(successRemoveUserDevice());
        dispatch(getUserDevices());
      })
      .catch((error) => {
        console.log('Error on remove user devices: ', error);
        dispatch(failureRemoveUserDevice(error));
      });
  };
}

export function removeAllUserDevices() {
  return (dispatch, getState) => {
    const { user: { authToken }, device: { devices } } = getState();
    dispatch(removingAllUserDevices());
    return Promise.all(
      devices.map(
        ({ uniqueDeviceId }) => removeAccountDevice({ casDeviceId: uniqueDeviceId }, authToken),
      ),
    )
      .then(() => {
        dispatch(successRemoveAllUserDevices());
        dispatch(getUserDevices());
      })
      .catch((error) => {
        console.error('Error on remove all user account device: ', error);
        dispatch(failureRemoveAllUserDevices(error));
      });
  };
}
